import type { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  ModalCloseX,
  ModalHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import { ContextMenu } from "./ContextMenu"
import { DateTimeInput } from "./DateTimeInput"
import {
  ActivityIcon,
  ActivityName,
} from "src/components/Activity"
import styles from "src/styles/entryModal.module.scss"
import type {
  EditableSubEntry,
  EditableUserEntry,
} from "src/types"

interface Props {
  activityType: ActivityType;
  currentSubEntry?: EditableSubEntry;
  currentUserEntry: EditableUserEntry;
  setCurrentUserEntry: (userEntry: EditableUserEntry) => void;
  closeBtnId: string;
  readOnly?: boolean;
}

export function SubEntryHeader(props: Props) {
  const {
    activityType,
    currentSubEntry,
    currentUserEntry,
    setCurrentUserEntry,
    closeBtnId,
    readOnly = false,
  } = props

  return (
    <ModalHeading>
      <div className={styles.headingContent}>
        <ActivityIcon
          activityType={activityType}
          className={styles.activityIcon}
        />
        <ActivityName activityType={activityType} />
        <DateTimeInput
          currentUserEntry={currentUserEntry}
          setCurrentUserEntry={setCurrentUserEntry}
          readonly={readOnly}
        />
      </div>
      {!readOnly && (
        <ContextMenu
          currentSubEntry={currentSubEntry}
          currentUserEntry={currentUserEntry}
        />
      )}
      <ModalCloseX id={closeBtnId} />
    </ModalHeading>
  )
}
